(function() {
    'use strict';

    AgreementsWelcomeController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsWelcomeController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;

        function save() {
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }
    }

    angular.module('ipmApp').component('agreementsWelcome', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-welcome/agreements-welcome.html',
        controller: AgreementsWelcomeController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
